module.exports = __webpack_public_path__ + "static/media/1.2a772b3a.jpg";